import {
  ALTO_MDD_PHASE_2,
  ALZHEIMER_TEST_TRIAL,
  CYBIN_GAD_PHASE_2,
  ENGRAIL_GAD_PHASE_2,
  MINDMED_GAD_PHASE_3,
  MINDMED_GAD_PHASE_3_SISTER_TRIAL,
  RECOGNIFY_SCHIZ_PHASE_2,
  SANOFI_AQUA_PHASE_3,
  SANOFI_COAST_2_PHASE_3,
  SANOFI_MS_PHASE_3_1,
  SANOFI_MS_PHASE_3_2,
  VISTAGEN_PALISADE_3,
  VISTAGEN_PALISADE_4,
} from '@modules/trials/constants/trials'

type Medication = { displayName: string; value: string }

type MedicationByTrial = {
  medications: Medication[]
  nctIds: string[]
}
type MedicationByCondition = {
  conditions: string[]
  medications: Medication[]
  therapeuticAreas: string[]
}

// Followed list in https://linear.app/withpower/issue/POW-12569/ordering-of-medications-in-medication-questions
export const PopularMedicationsByNctId: MedicationByTrial[] = [
  {
    medications: [
      { displayName: 'Sertraline (Zoloft)', value: 'Sertraline' },
      { displayName: 'Escitalopram (Lexapro)', value: 'Escitalopram' },
      { displayName: 'Fluoxetine (Prozac)', value: 'Fluoxetine' },
      { displayName: 'Duloxetine (Cymbalta)', value: 'Duloxetine' },
      { displayName: 'Venlafaxine (Effexor)', value: 'Venlafaxine' },
      { displayName: 'Citalopram (Celexa)', value: 'Citalopram' },
      { displayName: 'Bupropion (Wellbutrin)', value: 'Bupropion' },
      { displayName: 'Paroxetine (Paxil)', value: 'Paroxetine' },
    ],
    // Major Depressive Disorder
    nctIds: [ALTO_MDD_PHASE_2.nctId],
  },
  {
    medications: [
      { displayName: 'Aducanumab (Aduhelm)', value: 'Aducanumab' },
      { displayName: 'Lecanemab (Leqembi)', value: 'Lecanemab' },
      { displayName: 'Donepezil (Aricept)', value: 'Donepezil' },
      { displayName: 'Rivastigmine (Exelon)', value: 'Rivastigmine' },
      { displayName: 'Galantamine (Razadyne)', value: 'Galantamine' },
      { displayName: 'Sertraline (Zoloft)', value: 'Sertraline' },
      { displayName: 'Citalopram (Celexa)', value: 'Citalopram' },
      { displayName: 'Escitalopram (Lexapro)', value: 'Escitalopram' },
      { displayName: 'Memantine (Namenda)', value: 'Memantine' },
      { displayName: 'Lorazepam (Ativan)', value: 'Lorazepam' },
      { displayName: 'Oxazepam (Serax)', value: 'Oxazepam' },
      { displayName: 'Buspirone (Buspar)', value: 'Buspirone' },
      { displayName: 'Valproic Acid (Depakote)', value: 'Valproic Acid' },
      { displayName: 'Carbamazepine (Tegretol)', value: 'Carbamazepine' },
    ],
    // Alzheimer's Disease
    nctIds: [ALZHEIMER_TEST_TRIAL.nctId],
  },
  {
    medications: [
      { displayName: 'Sertraline (Zoloft)', value: 'Sertraline' },
      { displayName: 'Escitalopram (Lexapro)', value: 'Escitalopram' },
      { displayName: 'Venlafaxine (Effexor)', value: 'Venlafaxine' },
      { displayName: 'Duloxetine (Cymbalta)', value: 'Duloxetine' },
      { displayName: 'Paroxetine (Paxil)', value: 'Paroxetine' },
      { displayName: 'Fluoxetine (Prozac)', value: 'Fluoxetine' },
      { displayName: 'Buspirone (BuSpar)', value: 'Buspirone' },
      { displayName: 'Alprazolam (Xanax)', value: 'Alprazolam' },
      { displayName: 'Lorazepam (Ativan)', value: 'Lorazepam' },
    ],
    // Generalized Anxiety Disorder
    nctIds: [
      ENGRAIL_GAD_PHASE_2.nctId,
      CYBIN_GAD_PHASE_2.nctId,
      MINDMED_GAD_PHASE_3.nctId,
      MINDMED_GAD_PHASE_3_SISTER_TRIAL.nctId,
    ],
  },
  {
    medications: [
      { displayName: 'Aripiprazole (Abilify)', value: 'Aripiprazole' },
      { displayName: 'Risperidone (Risperdal)', value: 'Risperidone' },
      { displayName: 'Olanzapine (Zyprexa)', value: 'Olanzapine' },
      { displayName: 'Quetiapine (Seroquel)', value: 'Quetiapine' },
      { displayName: 'Paliperidone (Invega)', value: 'Paliperidone' },
    ],
    // Schizophrenia
    nctIds: [RECOGNIFY_SCHIZ_PHASE_2.nctId],
  },
  {
    medications: [
      { displayName: 'Sertraline (Zoloft)', value: 'Sertraline' },
      { displayName: 'Paroxetine (Paxil)', value: 'Paroxetine' },
      { displayName: 'Escitalopram (Lexapro)', value: 'Escitalopram' },
      { displayName: 'Fluoxetine (Prozac)', value: 'Fluoxetine' },
      { displayName: 'Venlafaxine (Effexor)', value: 'Venlafaxine' },
      { displayName: 'Clonazepam (Klonopin)', value: 'Clonazepam' },
      { displayName: 'Alprazolam (Xanax)', value: 'Alprazolam' },
      { displayName: 'Propranolol (Inderal)', value: 'Propranolol' },
    ],
    // Social Anxiety
    nctIds: [VISTAGEN_PALISADE_3.nctId, VISTAGEN_PALISADE_4.nctId],
  },
  {
    medications: [
      { displayName: 'Dupilumab (Dupixent)', value: 'Dupilumab' },
      { displayName: 'Tralokinumab (Adbry)', value: 'Tralokinumab' },
      { displayName: 'Upadacitinib (Rinvoq)', value: 'Upadacitinib' },
      { displayName: 'Abrocitinib (Cibinqo)', value: 'Abrocitinib' },
      { displayName: 'Hydrocortisone', value: 'Hydrocortisone' },
      { displayName: 'Betamethasone', value: 'Betamethasone' },
      { displayName: 'Clobetasol', value: 'Clobetasol' },
      { displayName: 'Tacrolimus (Protopic)', value: 'Tacrolimus' },
      { displayName: 'Pimecrolimus (Elidel)', value: 'Pimecrolimus' },
      { displayName: 'Crisaborole (Eucrisa)', value: 'Crisaborole' },
    ],
    // Atopic Dermatitis
    nctIds: [SANOFI_AQUA_PHASE_3.nctId, SANOFI_COAST_2_PHASE_3.nctId],
  },
  {
    medications: [
      { displayName: 'Lemtrada (Alemtuzumab)', value: 'Alemtuzumab' },
      { displayName: 'Mavenclad (Cladribine)', value: 'Cladribine' },
      { displayName: 'Aubagio (Teriflunomide)', value: 'Teriflunomide' },
      { displayName: 'Neoral (Cyclosporine)', value: 'Cyclosporine' },
      { displayName: 'Sandimmune (Cyclosporine)', value: 'Cyclosporine' },
      { displayName: 'Novantrone (Mitoxantrone)', value: 'Mitoxantrone' },
      { displayName: 'Cytoxan (Cyclophosphamide)', value: 'Cyclophosphamide' },
      { displayName: 'Gilenya (Fingolimod)', value: 'Fingolimod' },
      { displayName: 'Imuran (Azathioprine)', value: 'Azathioprine' },
    ],
    // Multiple Sclerosis
    nctIds: [SANOFI_MS_PHASE_3_1.nctId, SANOFI_MS_PHASE_3_2.nctId],
  },
]

// created using ChatGPT asking "What are the most popular medications for XXX"
export const PopularMedicationsByCondition: MedicationByCondition[] = [
  {
    conditions: ["alzheimer's disease"],
    medications: [
      { displayName: 'Aducanumab (Aduhelm)', value: 'Aducanumab' },
      { displayName: 'Lecanemab (Leqembi)', value: 'Lecanemab' },
      { displayName: 'Donepezil (Aricept)', value: 'Donepezil' },
      { displayName: 'Rivastigmine (Exelon)', value: 'Rivastigmine' },
      { displayName: 'Galantamine (Razadyne)', value: 'Galantamine' },
      { displayName: 'Sertraline (Zoloft)', value: 'Sertraline' },
      { displayName: 'Citalopram (Celexa)', value: 'Citalopram' },
      { displayName: 'Escitalopram (Lexapro)', value: 'Escitalopram' },
      { displayName: 'Memantine (Namenda)', value: 'Memantine' },
      { displayName: 'Lorazepam (Ativan)', value: 'Lorazepam' },
      { displayName: 'Oxazepam (Serax)', value: 'Oxazepam' },
      { displayName: 'Buspirone (Buspar)', value: 'Buspirone' },
      { displayName: 'Valproic Acid (Depakote)', value: 'Valproic Acid' },
      { displayName: 'Carbamazepine (Tegretol)', value: 'Carbamazepine' },
    ],
    therapeuticAreas: ['neurology'],
  },
  {
    conditions: ['schizophrenia'],
    medications: [
      { displayName: 'Aripiprazole (Abilify)', value: 'Aripiprazole' },
      { displayName: 'Olanzapine (Zyprexa)', value: 'Olanzapine' },
      { displayName: 'Quetiapine (Seroquel)', value: 'Quetiapine' },
      { displayName: 'Risperidone (Risperdal)', value: 'Risperidone' },
      { displayName: 'Clozapine (Clozaril or Versacloz)', value: 'Clozapine' },
      { displayName: 'Haloperidol (Haldol)', value: 'Haloperidol' },
      { displayName: 'Chlorpromazine (Thorazine)', value: 'Chlorpromazine' },
      { displayName: 'Lurasidone (Latuda)', value: 'Lurasidone' },
      { displayName: 'Ziprasidone (Geodon)', value: 'Ziprasidone' },
      { displayName: 'Paliperidone (Invega)', value: 'Paliperidone' },
    ],
    therapeuticAreas: ['psychiatry'],
  },
  {
    conditions: ['major depressive disorder'],
    medications: [
      { displayName: 'Sertraline (Zoloft)', value: 'Sertraline' },
      { displayName: 'Fluoxetine (Prozac)', value: 'Fluoxetine' },
      { displayName: 'Citalopram (Celexa)', value: 'Citalopram' },
      { displayName: 'Escitalopram (Lexapro)', value: 'Escitalopram' },
      { displayName: 'Paroxetine (Paxil)', value: 'Paroxetine' },
      { displayName: 'Venlafaxine (Effexor)', value: 'Venlafaxine' },
      { displayName: 'Desvenlafaxine (Pristiq)', value: 'Desvenlafaxine' },
      { displayName: 'Duloxetine (Cymbalta)', value: 'Duloxetine' },
      { displayName: 'Milnacipran (Savella)', value: 'Milnacipran' },
      { displayName: 'Levomilnacipran (Fetzima)', value: 'Levomilnacipran' },
    ],
    therapeuticAreas: ['psychiatry'],
  },
  {
    conditions: ['atopic dermatitis'],
    medications: [
      { displayName: 'Dupilumab (Dupixent)', value: 'Dupilumab' },
      { displayName: 'Tralokinumab (Adbry)', value: 'Tralokinumab' },
      { displayName: 'Upadacitinib (Rinvoq)', value: 'Upadacitinib' },
      { displayName: 'Abrocitinib (Cibinqo)', value: 'Abrocitinib' },
      { displayName: 'Hydrocortisone', value: 'Hydrocortisone' },
      { displayName: 'Betamethasone', value: 'Betamethasone' },
      { displayName: 'Clobetasol', value: 'Clobetasol' },
      { displayName: 'Tacrolimus (Protopic)', value: 'Tacrolimus' },
      { displayName: 'Pimecrolimus (Elidel)', value: 'Pimecrolimus' },
      { displayName: 'Crisaborole (Eucrisa)', value: 'Crisaborole' },
    ],
    therapeuticAreas: ['dermatology'],
  },
  {
    conditions: ['multiple sclerosis'],
    medications: [
      { displayName: 'Lemtrada (Alemtuzumab)', value: 'Alemtuzumab' },
      { displayName: 'Mavenclad (Cladribine)', value: 'Cladribine' },
      { displayName: 'Aubagio (Teriflunomide)', value: 'Teriflunomide' },
      { displayName: 'Neoral (Cyclosporine)', value: 'Cyclosporine' },
      { displayName: 'Sandimmune (Cyclosporine)', value: 'Cyclosporine' },
      { displayName: 'Novantrone (Mitoxantrone)', value: 'Mitoxantrone' },
      { displayName: 'Cytoxan (Cyclophosphamide)', value: 'Cyclophosphamide' },
      { displayName: 'Gilenya (Fingolimod)', value: 'Fingolimod' },
      { displayName: 'Imuran (Azathioprine)', value: 'Azathioprine' },
    ],
    therapeuticAreas: ['neurology'],
  },
  {
    conditions: ['default'],
    medications: [
      { displayName: 'Sertraline (Zoloft)', value: 'Sertraline' },
      { displayName: 'Fluoxetine (Prozac)', value: 'Fluoxetine' },
      { displayName: 'Escitalopram (Lexapro)', value: 'Escitalopram' },
      { displayName: 'Venlafaxine (Effexor)', value: 'Venlafaxine' },
      { displayName: 'Quetiapine (Seroquel)', value: 'Quetiapine' },
      { displayName: 'Aripiprazole (Abilify)', value: 'Aripiprazole' },
      { displayName: 'Risperidone (Risperdal)', value: 'Risperidone' },
      { displayName: 'Lithium (Lithobid)', value: 'Lithium' },
      { displayName: 'Clonazepam (Klonopin)', value: 'Clonazepam' },
      { displayName: 'Buspirone (BuSpar)', value: 'Buspirone' },
    ],
    therapeuticAreas: ['psychiatry'],
  },
]

export const DefaultPopularMedications: Medication[] = [
  { displayName: 'Acetaminophen', value: 'Acetaminophen' },
  { displayName: 'Albuterol', value: 'Albuterol' },
  { displayName: 'Amlodipine', value: 'Amlodipine' },
  { displayName: 'Atorvastatin', value: 'Atorvastatin' },
  { displayName: 'Levothyroxine', value: 'Levothyroxine' },
  { displayName: 'Lisinopril', value: 'Lisinopril' },
  { displayName: 'Metformin', value: 'Metformin' },
  { displayName: 'Metoprolol', value: 'Metoprolol' },
  { displayName: 'Omeprazole', value: 'Omeprazole' },
  { displayName: 'Simvastatin', value: 'Simvastatin' },
]
